// Hooks
import React, { useState } from "react";
import "./Authentication.css";
// import loginbg from "../Images/LoginBG.jpeg";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FaEyeSlash, FaHome } from 'react-icons/fa';
import { FaEye } from 'react-icons/fa';
import AuthService from "../Services/AuthService";
import { reactLocalStorage } from "reactjs-localstorage";


export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [passord, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const mailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // const passWord = passord.length >= 4 && passord.length <= 15;

  // >>>Handle Login<<<
  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = email.trim() !== "" && passord.trim() !== "";
    if (isValid) {
      if (!email.match(mailFormat)) {
        toast.error("Invalid Email")
      } else {
        const data = {
          email: email,
          password: passord,
        };
        setSubmitting(true);
        try {
          const res = await AuthService.getLogin(data);

          if (res?.status && res?.data?.token) {
            // Both consumers are used in this app: keep their session values in sync.
            const storedRole = String(res.data.role || "superadmin")
              .trim()
              .toLowerCase()
              .replace(/^super\s*admin$/, "superadmin");

            const session = {
              token: res.data.token,
              role: storedRole,
              city: res.data.city?._id || "",
              uid: res.data._id || "",
            };
            Object.entries(session).forEach(([key, value]) => {
              localStorage.setItem(key, value);
              reactLocalStorage.set(key, value);
            });
            toast.success("Logged in successfully!");
            navigate('/', { replace: true });
          } else {
            toast.error(res?.message || "Unable to sign in. Please check your credentials.");
          }
        } catch (error) {
          console.error("Admin login failed:", error);
          toast.error(error?.message || "Unable to sign in. Please try again.");
        } finally {
          setSubmitting(false);
        }

      }
    } else {
      toast.error("Please fill all the Inputs..")
    }
  };

  const togglePasswordVisibility = () => {
    setShow(!show);
  };

  return (
    <>
      <section
        className="LoginPage"
      // style={{ backgroundImage: `url(${loginbg})` }}
      >
        <div className="LoginBgOverlay" />
        <div className="LoginForm">
          <div className="LoginTop">
            <h5 className="LoginHead">Sign in</h5>
          </div>
          <div className="LoginBtm">
            <form action="" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  name="email"
                  id="exampleEmail"
                  placeholder="Email here..."
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                />
              </div>
              <div className="form-group pass_input">
                <input
                  onChange={(e) => setPassword(e.target.value)}
                  value={passord}
                  name="password"
                  id="examplePassword"
                  placeholder="Password here..."
                  type={show ? "text" : "password"}
                  className="form-control"
                />
                <div className="eye_icon" onClick={togglePasswordVisibility}>
                  {show ? <FaEyeSlash /> : <FaEye />}
                </div>
              </div>
              <button
                className="LoginBtn mt-5"
                type="submit"
                disabled={submitting}
              >
                {submitting ? "SIGNING IN..." : "SIGN IN"}
              </button>
            </form>
          </div>
        </div>
      </section>

    </>
  );
}
